module.exports = __webpack_public_path__ + "media/img/mr-nhat-2c4fbb98.png";